import React, { useState } from 'react';
import { ExportProvider } from '../variation-export/ExportContext';
import Modal from './Modal';
import AdvancedExportModal from '../variation-export/Modal';

const QuickExportModal = ({ isOpen, onClose }) => {
    const [isAdvancedSelection, setIsAdvancedSelection] = useState(false);
    const handleClose = () => {
        onClose();
        setIsAdvancedSelection(false);
    };

    const handleCloseAdvanced = () => {
        setIsAdvancedSelection(false);
    };

    const handleContinue = () => {
        setIsAdvancedSelection(false);
    };

    const switchToAdvancedSelection = () => {
        setIsAdvancedSelection(true);
    };

    return (
        <ExportProvider>
            {isAdvancedSelection ? (
                <AdvancedExportModal isOpen={isOpen} onClose={handleCloseAdvanced} onContinue={handleContinue} />
            ) : (
                <Modal isOpen={isOpen} onClose={handleClose} onSwitchToAdvancedSelection={switchToAdvancedSelection} />
            )}
        </ExportProvider>
    );
};

export default QuickExportModal;
